// Supermove
import {Form} from '@supermove/hooks';

export type ProjectTypeFeatureFormFieldsType = {
  projectTypeId: string;
  feature: string;
  isEnabled: boolean;
};

export type ProjectTypeFeatureFormType = Form<{
  projectTypeFeatureForm: ProjectTypeFeatureFormFieldsType;
}>;

const _new = ({projectTypeId, feature, isEnabled}: ProjectTypeFeatureFormFieldsType) => ({
  projectTypeId,
  feature,
  isEnabled,
});

const toForm = ({projectTypeId, feature, isEnabled}: ProjectTypeFeatureFormFieldsType) => ({
  projectTypeId,
  feature,
  isEnabled,
});

const toMutation = ({projectTypeId, feature, isEnabled}: ProjectTypeFeatureFormFieldsType) => ({
  projectTypeId,
  feature,
  isEnabled,
});

const ProjectTypeFeatureForm = {
  new: _new,
  toForm,
  toMutation,
};

export default ProjectTypeFeatureForm;
